import { render } from "./PostalCodeBrowseItem.vue?vue&type=template&id=3cddc262"
import script from "./PostalCodeBrowseItem.vue?vue&type=script&lang=js"
export * from "./PostalCodeBrowseItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__